import { render, staticRenderFns } from "./OlympicsComp.vue?vue&type=template&id=89ac5dfa&scoped=true"
import script from "./OlympicsComp.vue?vue&type=script&lang=js"
export * from "./OlympicsComp.vue?vue&type=script&lang=js"
import style0 from "./OlympicsComp.vue?vue&type=style&index=0&id=89ac5dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ac5dfa",
  null
  
)

/* custom blocks */
import block0 from "./OlympicsComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports